// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dfef26da","239":"23785899","453":"55d7919c","667":"b3424857"}[chunkId] + ".chunk.js";
};